import { NumberFormatter, Stack, Text } from "@mantine/core";
import { useLanguage } from "../../../stores/LanguageStore";

const Price = ({ defaultPrice, futurePrice, reccurence, active, subscription_id }) => {
  const lang = useLanguage((s) => s.language);  

  if (futurePrice === defaultPrice || !active || !subscription_id)
    return (
      <Stack gap={0}>
        {active && <Text size="md">{lang.pricing.actual}</Text>}
        <Text size="lg" c={"primary"}>
          <b style={{ fontSize: 64, marginRight: 8 }}>
            <NumberFormatter value={futurePrice?.toFixed(0)} />€
          </b>{" "}
          {reccurence === "monthly"
            ? lang.pricing.monthly_payment
            : lang.pricing.annual_payment}
        </Text>
      </Stack>
    );
  return (
    <Stack gap={"sm"}>
      <Stack gap={0}>
        <Text size="md">{lang.pricing.actual}</Text>
        <Text size="sm">
          <b style={{ fontSize: 32, marginRight: 8 }}>
            <NumberFormatter value={defaultPrice?.toFixed(0)} />€
          </b>{" "}
          {reccurence === "monthly"
            ? lang.pricing.monthly_payment
            : lang.pricing.annual_payment}
        </Text>
      </Stack>
      <Stack gap={0}>
        <Text size="md"> {lang.pricing.additional_options} </Text>
        <Text size="lg" mt={-5} c={"primary"}>
          <b style={{ fontSize: 64, marginRight: 8 }}>
            <NumberFormatter value={(futurePrice - defaultPrice)?.toFixed(0)} />
            €
          </b>{" "}
          {reccurence === "monthly"
            ? lang.pricing.monthly_payment
            : lang.pricing.annual_payment}
        </Text>

        <Text fw={600} c={"red"}>{lang.pricing.prorata}</Text>
      </Stack>
    </Stack>
  );
};

export default Price;
